import { useEffect, MutableRefObject } from 'react';
import { ChangeEvent } from 'react';
import { Utility } from 'helpers/UtilityHelpers'
import { Code } from 'constants/codes';

const onFieldValueChange = (
  e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
  formData: any,
  setFormData: React.Dispatch<React.SetStateAction<any>>
) => {
  let { id, value } = e.target;
  id = id.toLowerCase()
  if (id.includes("_phone") || id.includes("_cell") || id.includes("_mobile") || id.includes("_fax")) {
    value = Utility.Format.PhoneTyping(value);
  } else if (id.includes("_date") || id.includes("_dob")) {
    //console.log("Raw Date Input:", value);
    value = value ? `${value}T10:00:00` : '';
  } 
  else if (id.includes("_health_card")) {
    value = value.replace(/\D/g, "");
  } 

  setFormData({
    ...formData,
    [id]: id.includes('_id') ? Number(value) : value,
  });

};

const getFieldValue = (e: ChangeEvent<HTMLSelectElement>): number => {
  const { value } = e.target;
  return Number(value); // convert string to number
};

const onMultiFieldValueChange = (
  e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
  multiData: any,
  setMultiData: React.Dispatch<React.SetStateAction<any>>,
  lastUpdated: string = ""
) => {

  let { id, value } = e.target;

  value = value.replace("\"", "''"); // Remove all double quotes
  //value = value.replace("\\", "/"); // Remove backslash to slash

  if(lastUpdated)
  {
    const userName = Utility.Storage.UserName();
    setMultiData({
      ...multiData,
      [id]: value,
      [lastUpdated]: userName + ' ' + Utility.Format.Date(new Date(), Code.Format.DateTime.Full),
    });
  }
  else
  {
    setMultiData({
      ...multiData,
      [id]: value,
    });
  }
  
};

const onMultiCheckChange = (
  e: ChangeEvent<HTMLInputElement>,
  multiData: any,
  setMultiData: React.Dispatch<React.SetStateAction<any>>,
  lastUpdated: string = ""
) => {
  const { id, checked } = e.target;

  const value  = checked ? '1' : '0';

  //console.log("Checkbox Change:", id, checked);

  if(lastUpdated) {
    setMultiData({
      ...multiData,
      [id]: value,
      [lastUpdated]: Utility.Storage.UserName() + ' ' + Utility.Format.Date(new Date(), Code.Format.DateTime.Full),
    });
  } else {
    setMultiData({
      ...multiData,
      [id]: value,
    });
  }
};

const setValueToJsonString = (
  e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
  setState: React.Dispatch<React.SetStateAction<string | undefined>>
) => {
  let { id, value } = e.target;
  setState((prevJson) => {
    if (!prevJson) return JSON.stringify({ [id]: value });

    try {
      const data = JSON.parse(prevJson);
      data[id] = value;
      return JSON.stringify(data);
    } catch (error) {
      console.error("setValueToJsonString:", error);
      return prevJson;
    }
  });
};

const getValueFromJsonString = (jsonString: string | undefined, key: string): string | number | undefined => {
  try {
    if(jsonString){
      const data = JSON.parse(jsonString);
      return data[key] ?? null; 
    }
    return '';
  } catch (error) {
    console.error("getValueFromJsonString:", error);
    return '';
  }
};

const showHideFilterOnListView = (
  filterListRef: MutableRefObject<HTMLElement | null>
) => {
  if (filterListRef.current) {
    if (filterListRef.current.style.display === 'none' || filterListRef.current.style.display === '') {
      filterListRef.current.style.display = 'block';
    } else {
      filterListRef.current.style.display = 'none';
    }
  }
};

const popupEditForm = (
  iframeRef: React.RefObject<HTMLIFrameElement>, 
  url: string,
  para1: string = '',
  value1: string | number | Date | undefined = '',
  para2: string = '', 
  value2: string | number | Date | undefined = '',
  para3: string = '',
  value3: string | number | Date | undefined = '',
  para4: string = '',
  value4: string | number | Date | undefined = '',
  para5: string = '',
  value5: string | number | Date | undefined = '',
  para6: string = '',
  value6: string | number | Date | undefined = '',
  para7: string = '',
  value7: string | number | Date | undefined = '',
  para8: string = '',
  value8: string | number | Date | undefined = '',
) => {

  if(!url.includes("/")) { url = url + '/new'; } 
  if(para1 && value1) { url = url + `?${para1}=${value1}`; }
  if(para2 && value2) { url = url + `&${para2}=${value2}`; }
  if(para3 && value3) { url = url + `&${para3}=${value3}`; }
  if(para4 && value4) { url = url + `&${para4}=${value4}`; }
  if(para5 && value5) { url = url + `&${para5}=${value5}`; }
  if(para6 && value6) { url = url + `&${para6}=${value6}`; }
  if(para7 && value7) { url = url + `&${para7}=${value7}`; }
  if(para8 && value8) { url = url + `&${para8}=${value8}`; }
  
  if (iframeRef.current) {
    iframeRef.current.src = `/${url}`;
  }

  const size = Utility.Convert.FormWidth(url);

  //console.log("Popup URL+Size:", url, size);

  const popupElement = document.querySelector('.popup');
  if (popupElement) {
    popupElement.className = `popup active popup-col${size.toString()}`;
  }
};

const popupEditForm2 = (
  normal: boolean,
  iframeRef: React.RefObject<HTMLIFrameElement>, 
  iframeRef2: React.RefObject<HTMLIFrameElement>, 
  url: string,
  para1: string = '',
  value1: string | number | undefined = '',
  para2: string = '', 
  value2: string | number | undefined = '',
  para3: string = '',
  value3: string | number | undefined = '',
  para4: string = '',
  value4: string | number | undefined = '',
  para5: string = '',
  value5: string | number | undefined = '',
  para6: string = '',
  value6: string | number | undefined = '',
  para7: string = '',
  value7: string | number | undefined = '',
  para8: string = '',
  value8: string | number | undefined = '',
) => {

  if(!url.includes("/")) { url = url + '/new'; } 
  if(para1 && value1) { url = url + `?${para1}=${value1}`; }
  if(para2 && value2) { url = url + `&${para2}=${value2}`; }
  if(para3 && value3) { url = url + `&${para3}=${value3}`; }
  if(para4 && value4) { url = url + `&${para4}=${value4}`; }
  if(para5 && value5) { url = url + `&${para5}=${value5}`; }
  if(para6 && value6) { url = url + `&${para6}=${value6}`; }
  if(para7 && value7) { url = url + `&${para7}=${value7}`; }
  if(para8 && value8) { url = url + `&${para8}=${value8}`; }

  
  
  if (iframeRef.current && iframeRef2.current) {

    if(normal){
      iframeRef.current.src = '/pages/blank.html';
      iframeRef2.current.src = '/pages/blank.html';
      const popupElement = document.querySelector('.popup2');
      if (popupElement) {
        popupElement.className = `popup2`;
      }
    }
    else{
      if(iframeRef.current.src.includes('/exam/')){
        iframeRef.current.src = '/pages/blank.html';
        const popupElement = document.querySelector('.popup');
        if (popupElement) {
          popupElement.className = `popup`;
        }
      }
    }

    //console.log("Current Iframe1 Src:", iframeRef.current.src);
    //console.log("Current Iframe2 Src:", iframeRef2.current.src);
    if(iframeRef.current.src.includes('/pages/blank.html')){
      iframeRef.current.src = `/${url}`;
      const size = Utility.Convert.FormWidth(url);

      //console.log("Popup URL+Size:", url, size);

      const popupElement = document.querySelector('.popup');
      if (popupElement) {
        popupElement.className = `popup active brn popup-col${size.toString()}`;
      }
    }
    else{
      iframeRef2.current.src = `/${url}`;
      const size = Utility.Convert.FormWidth(url);

      //console.log("Popup2 URL+Size:", url, size);

      const popupElement = document.querySelector('.popup2');
      if (popupElement) {
        popupElement.className = `popup2 active brn popup-col${size.toString()}`;
      }
    }
    
  }

  
};



const useOutsideClickToHide = (
  refs: React.RefObject<HTMLElement>[],
  callbacks: (() => void)[],
  hideElements: boolean = false
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      refs.forEach((ref, index) => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          callbacks[index]?.(); // Ensure callback exists before calling
          if (hideElements && ref.current) {
            ref.current.style.display = "none";
          }
        }
      });
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs, callbacks, hideElements]);
};

interface showContextMenuProps<T> {
  event: React.MouseEvent;
  data: T;
  setMenuPosition: (position: { x: number; y: number }) => void;
  setSelectedData: (data: T) => void;
  setShowMenu: (show: boolean) => void;
}

const showContextMenu = <T>({
  event,
  data,
  setMenuPosition,
  setSelectedData,
  setShowMenu
}: showContextMenuProps<T>): void => {
  //if (event.ctrlKey || event.metaKey) return;
  event.preventDefault();
  setMenuPosition({ x: event.clientX, y: event.clientY });
  setSelectedData(data);
  setShowMenu(true);
};

const toggleSelection = (key: string | undefined, setSelectedItems: Function) => {
  setSelectedItems((prevSelected: string[]) =>
    prevSelected.includes(key!)
      ? prevSelected.filter((itemKey) => itemKey !== key) // Deselect if already selected
      : [...prevSelected, key] // Select if not selected
  );
};

const toggleSelectAll = (isAllSelected: boolean, setSelectedItems: Function, data: any[],formName: string) => {
  if (isAllSelected) {
    setSelectedItems(data.map((item) => item[`${formName}_key`])); // Select all
  } else {
    setSelectedItems([]); // Deselect all
  }
};

const toggleSelectAllIds = (isAllSelected: boolean, setSelectedItems: Function, data: any[], formName: string) => {
  if (isAllSelected) {
    setSelectedItems(data.map((item) => item[`${formName}_id`].toString())); // Select all
  } else {
    setSelectedItems([]); // Deselect all
  }
};

const useSelectionEffect = (selectedItems: string[], setSelected: Function) => {
  useEffect(() => {
    //console.log("Page-List-selected:", selectedItems);
    selectedItems.length > 0 ? setSelected(true) : setSelected(false);
  }, [selectedItems]);
};

const handleSelectAll = (e: ChangeEvent<HTMLInputElement>, setSelectedItems: Function, data: any[],setSelectAllChecked: Function, formName: string) => {
  const isChecked = e.target.checked;
  setSelectAllChecked(isChecked);
  toggleSelectAll(isChecked, setSelectedItems, data, formName);
};

const handleSelectAllIds = (e: ChangeEvent<HTMLInputElement>, setSelectedItems: Function, data: any[],setSelectAllChecked: Function, formName: string) => {
  const isChecked = e.target.checked;
  setSelectAllChecked(isChecked);
  toggleSelectAllIds(isChecked, setSelectedItems, data, formName);
};

function mapFormData<T extends Record<string, any>>(data: T): Partial<T> {
  const mappedData: Partial<T> = {};

  Object.keys(data).forEach((key) => {
    const typedKey = key as keyof T;
    const value = data[typedKey];

    if (typeof value === "string") {
      if (Array.isArray(value)) {
        mappedData[typedKey] = value.map((item: any) =>
          typeof item === "object" && item !== null ? mapFormData(item) : item
        ) as T[keyof T];
      }
      else {
        if (isValidDate(value)) {

          //console.log(`mapFormData--raw-value:  `, value);
          //console.log(`mapFormData--convert-to-date: `, new Date(value));
        
          mappedData[typedKey] = new Date(value) as T[keyof T];
        } else {
          if(!typedKey.toString().endsWith("_pass")) {
            mappedData[typedKey] = Utility.Value.Text(value) as T[keyof T];
          } 
        }
      }
    } 
    else if (typeof value === "number") {
      if(typedKey.toString().endsWith("_id")) {
        mappedData[typedKey] = Utility.Value.Option(value) as T[keyof T];
      } else {
        mappedData[typedKey] = Utility.Value.Number(value) as T[keyof T];
      }
    }
    else if (value === null || value === undefined) {
      mappedData[typedKey] = undefined;
    }
    else  {
      mappedData[typedKey] = value;
    }
});

  return mappedData;
}

const isValidDate = (dateString: string): boolean => {
  // Ensure the string contains only valid date characters (digits, dashes, slashes, colons, and "T")
  if (!/^[0-9/:T-]+$/.test(dateString)) return false;

  // Try parsing as a Date object
  const parsedDate = new Date(dateString);

  // Ensure it's a valid date (not "Invalid Date") and matches expected input
  return !isNaN(parsedDate.getTime()) && dateString.includes("-");
};


const callParentTabClose = () => {
  if (window.frameElement) {
    const parentWindow = window.parent as any;
    
    if (parentWindow?.handleTabClose) {
      const tabIndex = Number(window.frameElement.id.replaceAll('panel', '')) - 1;
      parentWindow.handleTabClose(tabIndex);
    }
  }
};


export const Form = {
  Field: {
    Change: onFieldValueChange,
    Value: getFieldValue,
  },
  MultiValue: {
    Change: onMultiFieldValueChange,
    Check: onMultiCheckChange,
  },
  Json:{
    Set: setValueToJsonString,
    Get: getValueFromJsonString,
  },
  Show:{
    Filter: showHideFilterOnListView,
    Popup: popupEditForm,
    Popup2: popupEditForm2,
    ContextMenu: showContextMenu,
  },
  Click:{
    Outside: useOutsideClickToHide,
  },
  Parent:{
    TabClose: callParentTabClose,
  },
  Select:{
    All: handleSelectAll,
    AllIds: handleSelectAllIds,
    OnChange: useSelectionEffect,
    Toggle: toggleSelection
  },
  Map:{
    Data: mapFormData,
  }

}
